import React from 'react';
import { ForgotPassword } from './ForgotPassword';

export const ForgotPasswordPage = () => {
    return (
        < ForgotPassword />
    )
}